import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import youngFarmer from "../../assets/images/png/youngFarmer.png";

const Franchise = () => {
  return (
    <div className=" bg_clr_light_yellow">
      <div className="bg_dark_green_2 pt-5">
        <Container>
          <Row className="align-items-center flex-column-reverse flex-lg-row">
            <Col className="py-4" lg={6}>
              <h2
                style={{ lineHeight: "55px" }}
                className="text-white ff_heebo fw-bold fs_6xl_2"
              >
                <span className="clr_yellow">Farmer City</span> International
                Pvt Ltd Franchise Interest Form
              </h2>
              <p className="ff_heebo fs_md text-white pe-5">
                Welcome to Farmer City International Pvt Ltd! We are excited
                about your interest in joining our mission to revolutionize
                agriculture and empower farmers through our innovative phygital
                platform. Please fill out this form to express your interest in
                becoming a franchise owner.
              </p>
            </Col>
            <Col className="pe-0" lg={6}>
              <div>
                <img className="w-100" src={youngFarmer} alt="youngFarmer" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Franchise;
